import request from '../utils/Request';
import { Methods } from '../config';

const baseURL = 'serviceOperation';

const serviceOperationService = {
  getItems: (data) => {
    return request({
      method: Methods.POST,
      resource: `${baseURL}/data`,
      data,
    });
  },

  getItemsByGroupId: (groupId) => {
    return request({
      method: Methods.GET,
      resource: `${baseURL}/group/${encodeURIComponent(groupId)}`,
    });
  },

  updateItem: (data) => {
    return request({
      method: Methods.PUT,
      resource: `${baseURL}`,
      data,
    });
  },

  createItem: (data) => {
    return request({
      method: Methods.POST,
      resource: `${baseURL}`,
      data,
    });
  },

  deleteItem: (id) => {
    return request({
      method: Methods.DELETE,
      resource: `${baseURL}/${encodeURIComponent(id)}`,
    });
  },
};
export default serviceOperationService;
